import type { GridValueGetterParams } from '@mui/x-data-grid-pro'

export function getCustomField(params: GridValueGetterParams<uui.domain.client.rm.FormattedData>) {
  const customFields = params.row.customFields
  const customFieldName = params.field.replace('formattedData.customFields.', '')

  return customFields[customFieldName] ?? '-'
}
